import React from "react";
import InputSearchBox from "../../components/common/Input/InputSearchBox";
import { Col, Row } from "antd";
import TranslateText from "../../components/common/TranslateText";
import BaseButton from "../../components/common/Button/BaseButton";
import "../../assets/style/pageStyle/surverManager.scss";
import TableSurveyStatistics from "../../components/common/Table/TableSurveyStatistics";
import { useDispatch } from "react-redux";
import { setConfigStatistics } from "../../services/slice/SurveySlice";
import { useSelector } from "react-redux";
import { surveySelector } from "../../services/selector/index.";
const SurveyStatistics = () => {
  const surveyState = useSelector(surveySelector);
  const { configStatistics } = surveyState;
  const dispatch = useDispatch();
  return (
    <div className="wrapperSurveyStatistics">
      <Row className="headerPage">
        <h2 className="title">
          <TranslateText text={"Thống kê Khảo sát"} />
        </h2>
      </Row>
      <Row style={{ width: "100%" }}>
        <Col className="mr-5">
          <InputSearchBox
            width={435}
            placeholder={"Tìm kiếm theo tên cuộc khảo sát"}
            setText={(value) =>
              dispatch(
                setConfigStatistics({ ...configStatistics, textSearch: value })
              )
            }
          />
        </Col>

        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            // handleClick={() => dispatch(setOpenPUAddAcc(true))}
            width={120}
            typeBtn={"btnOrange"}
            content={`Xuất excel`}
          />
        </Col>
      </Row>
      <Row>
        <TableSurveyStatistics />
      </Row>
    </div>
  );
};

export default SurveyStatistics;
